// extracted by mini-css-extract-plugin
export var navTabletWrapper = "NavMenuTablet-module--navTabletWrapper--2mgCt";
export var navTabletBackdrop = "NavMenuTablet-module--navTabletBackdrop--37Soy";
export var searchMenu = "NavMenuTablet-module--searchMenu--QPjhM";